module.exports = __webpack_public_path__ + "img/kidsarcade.007db91e.jpg";